export var LinkTarget = /* @__PURE__ */ ((LinkTarget2) => {
  LinkTarget2["BLANK"] = "_blank";
  LinkTarget2["SELF"] = "_self";
  return LinkTarget2;
})(LinkTarget || {});
